function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3445_266)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.6017 22.0066C27.6017 21.2616 27.8341 20.5416 28.2611 19.9402H0.61107C0.241758 20.5424 0.0283203 21.2499 0.0283203 22.0066C0.0283203 22.7635 0.242508 23.4709 0.612133 24.0729H28.2614C27.8343 23.4714 27.6017 22.7515 27.6017 22.0066Z",
  fill: "#53AE67"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.3129 7.25345H10.9042C10.3803 7.25345 9.95554 7.6782 9.95554 8.20207V8.79045H9.67254C7.59767 8.79045 5.90967 10.4784 5.90967 12.5533C5.90967 14.6283 7.59773 16.3162 9.67254 16.3162H10.531C10.8288 16.9583 11.2332 17.5411 11.7202 18.043H23.4979C24.5887 16.9189 25.2615 15.3869 25.2615 13.7006V8.20214C25.2615 7.6782 24.8367 7.25345 24.3129 7.25345ZM9.67254 14.4189C8.64379 14.4189 7.80692 13.5821 7.80692 12.5533C7.80692 11.5246 8.64386 10.6877 9.67254 10.6877H9.95554V13.7005C9.95554 13.9435 9.96998 14.1831 9.99717 14.4189H9.67254Z",
  fill: "#1A854B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.3881 25.9701H3.73883C4.16589 26.5715 4.39846 27.2914 4.39846 28.0364C4.39846 28.9166 4.07508 29.7627 3.48789 30.4187C3.23839 30.6974 3.17602 31.0969 3.32864 31.4384C3.48133 31.78 3.82058 31.9999 4.19471 31.9999H28.0084C30.194 31.9999 31.972 30.2219 31.972 28.0364C31.972 27.2795 31.7578 26.5721 31.3881 25.9701Z",
  fill: "#1A854B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9052 0C18.3813 0 17.9565 0.42475 17.9565 0.948625V5.1225C17.9565 5.64637 18.3813 6.07113 18.9052 6.07113C19.4291 6.07113 19.8538 5.64637 19.8538 5.1225V0.948625C19.8538 0.42475 19.429 0 18.9052 0Z",
  fill: "#53AE67"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.3124 2.08694C15.7885 2.08694 15.3638 2.51169 15.3638 3.03557V5.12251C15.3638 5.64638 15.7885 6.07113 16.3124 6.07113C16.8363 6.07113 17.261 5.64638 17.261 5.12251V3.03557C17.261 2.51169 16.8363 2.08694 16.3124 2.08694Z",
  fill: "#53AE67"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3445_266"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

function SvgIcBookcoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBookcoffee);
export default __webpack_public_path__ + "static/media/ic_book&coffee.d1fe9c40.svg";
export { ForwardRef as ReactComponent };